import { useMutation, useQuery } from '@tanstack/react-query';
import fitStudioRequest from '../utils/request';
import Axios from 'axios';

const fitSurvey2Services = {
  useQueryGetLegacySurveyLists({ take, page, membeyType }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2', { take, page, membeyType }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey2`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              membeyType: queryKey[1].membeyType,
            },
          });

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      },
    );
  },
  useQueryGetLegacySurveyById({ surveyId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-by-id', { surveyId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2/${queryKey[1].surveyId}`,
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!surveyId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useMutationCreateLegacySurvey(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(`/legacy-survey2`, data);

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurvey(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2/${data.id}`,
            data.data,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyDisplay(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2/${data.id}/display`,
            {
              display: data.display,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationDeleteLegacySurvey(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey2/${data.id}`,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useQueryGetLegacySurveyPartLists({ take, page, surveyId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-part', { take, page, surveyId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey2-part`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              surveyId: queryKey[1].surveyId,
            },
          });

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      },
    );
  },
  useQueryGetLegacySurveyPartById({ partId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-part-by-id', { partId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-part/${queryKey[1].partId}`,
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!partId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useMutationCreateLegacySurveyPart(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(`/legacy-survey2-part`, data);

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyPart(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-part/${data.id}`,
            data.data,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyPartDisplay(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-part/${data.id}/display`,
            {
              display: data.display,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyPartIndex(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-part/${data.id}/index`,
            {
              index: data.index,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useMutationDeleteLegacySurveyPart(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey2-part/${data.id}`,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useQueryGetLegacySurveyQuestionLists({ take, page, partId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-question', { take, page, partId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey2-question`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              partId: queryKey[1].partId,
            },
          });

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      },
    );
  },
  useQueryGetLegacySurveyQuestionById({ questionId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-question-by-id', { questionId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-question/${queryKey[1].questionId}`,
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!questionId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useMutationCreateLegacySurveyQuestion(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey2-question`,
            data,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyQuestion(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-question/${data.id}`,
            data.data,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyQuestionDisplay(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-question/${data.id}/display`,
            {
              display: data.display,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurveyQuestionIndex(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-question/${data.id}/index`,
            {
              index: data.index,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useMutationDeleteLegacySurveyQuestion(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey2-question/${data.id}`,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useMutationUpdateLegacySurveyQuestionAnswerIndex(onSuccess, onError) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-question-answer/${data.id}/index`,
            {
              index: data.index,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
        onError,
      },
    );
  },
  useQueryGetLegacySurveyQuestionAnswer({ questionId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2-question-answer', { questionId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-question/${queryKey[1].questionId}`,
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!questionId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useMutationDownloadLegacySurveyQuestionByIdExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-question/download-excel/by-filter/${data.id}`,
            {
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'answer.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useQueryGetLegacySurveyUserAnswers(
    { take, page, answerId, memberType, searchText, startDate, endDate },
    onSuccess,
  ) {
    return useQuery(
      [
        'get-legacy-survey2-user-answer',
        { take, page, answerId, memberType, searchText, startDate, endDate },
      ],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`legacy-survey2-user-answer`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              answerId: queryKey[1].answerId,
              ...(queryKey[1].memberType && {
                memberType: queryKey[1].memberType,
              }),
              ...(queryKey[1].searchText && {
                searchText: queryKey[1].searchText,
              }),
              ...(queryKey[1].startDate && {
                startDate: queryKey[1].startDate,
              }),
              ...(queryKey[1].endDate && {
                endDate: queryKey[1].endDate,
              }),
            },
          });

          if (res.status === 200) {
            return res.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!answerId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useQueryGetLegacySurveyUserAnswerTexts(
    { take, page, questionId, memberType, searchText, startDate, endDate },
    onSuccess,
  ) {
    return useQuery(
      [
        'get-legacy-survey2-user-answer-text',
        { take, page, questionId, memberType, searchText, startDate, endDate },
      ],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-user-answer-text`,
            {
              params: {
                take: queryKey[1].take,
                page: queryKey[1].page,
                questionId: queryKey[1].questionId,
                ...(queryKey[1].memberType && {
                  memberType: queryKey[1].memberType,
                }),
                ...(queryKey[1].searchText && {
                  searchText: queryKey[1].searchText,
                }),
                ...(queryKey[1].startDate && {
                  startDate: queryKey[1].startDate,
                }),
                ...(queryKey[1].endDate && {
                  endDate: queryKey[1].endDate,
                }),
              },
            },
          );

          if (res.status === 200) {
            return res.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        refetchOnWindowFocus: false,
        enabled: !!questionId,
      },
    );
  },
  useMutationDownloadLegacyUserAnswersExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-user-answer/download-excel/by-filter`,
            {
              params: {
                take: data.take,
                page: data.page,
                answerId: data.answerId,
                ...(data.memberType && {
                  memberType: data.memberType,
                }),
                ...(data.searchText && {
                  searchText: data.searchText,
                }),
                ...(data.startDate && {
                  startDate: data.startDate,
                }),
                ...(data.endDate && {
                  endDate: data.endDate,
                }),
              },
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'answer.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useMutationDownloadLegacyUserAnswerTextsExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-user-answer-text/download-excel/by-filter`,
            {
              params: {
                take: data.take,
                page: data.page,
                questionId: data.questionId,
                ...(data.memberType && {
                  memberType: data.memberType,
                }),
                ...(data.searchText && {
                  searchText: data.searchText,
                }),
                ...(data.startDate && {
                  startDate: data.startDate,
                }),
                ...(data.endDate && {
                  endDate: data.endDate,
                }),
              },
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'answer.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useQueryGetLegacySurvey2PartnerLists(
    { take, page, surveyId, searchText, isPartner, answered, memberType },
    onSuccess,
  ) {
    return useQuery(
      [
        'get-legacy-survey2-partner-list',
        { take, page, surveyId, searchText, isPartner, answered, memberType },
      ],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-partner-list`,
            {
              params: {
                take: queryKey[1].take,
                page: queryKey[1].page,
                surveyId: queryKey[1].surveyId,
                ...(queryKey[1].searchText && {
                  searchText: queryKey[1].searchText,
                }),
                ...(queryKey[1].isPartner && {
                  isPartner: queryKey[1].isPartner,
                }),
                answered: queryKey[1].answered,
                ...(queryKey[1].memberType && {
                  memberType: queryKey[1].memberType,
                }),
              },
            },
          );

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!surveyId,
      },
    );
  },
  useQueryGetLegacySurvey2PartnerListById(
    { legacySurvey2PartnerId },
    onSuccess,
  ) {
    return useQuery(
      ['get-legacy-survey2-partner-list-by-id', { legacySurvey2PartnerId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-partner-list/${queryKey[1].legacyPopUpId}`,
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!legacySurvey2PartnerId,
        refetchOnWindowFocus: false,
      },
    );
  },
  useMutationCreateLegacySurvey2PartnerList(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey2-partner-list`,
            data,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUpdateLegacySurvey2PartnerList(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey2-partner-list/${data.id}`,
            {
              display: data.display,
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationDeleteLegacySurvey2PartnerList(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey2-partner-list/${data.id}`,
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      },
    );
  },
  useMutationUploadLegacySurvey2PartnerListsExcel(onSuccess) {
    return useMutation({
      mutationFn: async ({ data, surveyId }) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey2-partner-list/upload-excel/${surveyId}`,
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useMutationUploadLegacySurvey2PartnerListsByEvent(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey2-partner-list/create-partnerlist-by-event`,
            data,
          );

          return res.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useMutationDownloadLegacySurvey2PartnerListsExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-partner-list/download-excel/by-filter`,
            {
              params: {
                take: data.take,
                page: data.page,
                surveyId: data.surveyId,
                ...(data.searchText && { searchText: data.searchText }),
                ...(data.isPartner && { isPartner: data.isPartner }),
                answered: data.answered,
                ...(data.memberType && {
                  memberType: data.memberType,
                }),
              },
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'partnerlist.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useMutationDownloadLegacySurvey2PartnerListImportFormExcel(onSuccess) {
    return useMutation({
      mutationFn: async () => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-partner-list/download-excel/import-form`,
            {
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'partner-list-import-form.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useMutationUploadLegacySurvey2QuestionExcel(onSuccess, onError) {
    return useMutation({
      mutationFn: async ({ data, partId }) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey2-part/upload-excel/${partId}`,
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            },
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
      onError,
    });
  },
  useMutationDownloadLegacySurvey2QuestionExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey2-part/download-excel/by-filter/${data.partId}`,

            {
              responseType: 'blob',
            },
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'questionlist.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useQueryGetEventLists({ regStatus }, onSuccess) {
    return useQuery(
      ['get-legacy-survey2', { regStatus }],
      async ({ queryKey }) => {
        try {
          const res = await Axios.get(
            `${process.env.REACT_APP_EVENT_URL_API || 'https://dev-event-api.legacy.co.th'}/survey/events`,
            {
              params: {
                regStatus: queryKey[1].regStatus,
              },
            },
          );

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      },
    );
  },
  useQueryGetEventMemberLists({ id, limit, page, ticketStatus }, onSuccess) {
    return useQuery(
      [
        'get-legacy-survey2-event-member-list',
        { id, limit, page, ticketStatus },
      ],
      async ({ queryKey }) => {
        try {
          const res = await Axios.get(
            `${process.env.REACT_APP_EVENT_URL_API || 'https://dev-event-api.legacy.co.th'}/survey/events/${queryKey[1].id}/members`,
            {
              params: {
                limit: queryKey[1].limit,
                page: queryKey[1].page,
                ticketStatus: queryKey[1].ticketStatus,
              },
            },
          );

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!id,
      },
    );
  },
};

export default fitSurvey2Services;
